function Title({ title }) {
    return (
        <p class="flex items-start w-fit h-fit ml-10 mb-10 rounded-md shadow-lg shadow-[#13151c] text-base font-extralight leading-7 bg-[#13151c] p-2 text-[#f9f9f9]">
            {title}
        </p>
    );
}

export default Title;